import { getApiBaseUrl } from './config';
import { portalFetch } from '../auth/portalSession';

export interface DaySchedule {
  dayId: string;
  dayLabel: string;
  isOpen: boolean;
  workingHours: { startTime: string; endTime: string }[];
}

export const getScheduleApi = async (serviceType: number): Promise<DaySchedule[]> => {
  const response = await portalFetch('secretary', `${getApiBaseUrl()}/schedule?type=${serviceType}`);
  if (!response.ok) {
    throw new Error('Failed to fetch schedule');
  }
  const data = await response.json();
  // Backend returns { schedule: [...], count: number, scheduleType: number }
  return data.schedule || [];
};
